export default __webpack_public_path__ + "static/media/sampleReport6.8745a86a.png";